import {Stack, Typography} from '@mui/material'
import {useI18n} from 'store/Store'

const DanceItemInfo = ({dance, displayName, choreographersLabelKey}) => {
    const {i18n} = useI18n()

    return (
        <Stack spacing={0.5}>
            <Typography variant="subtitle2" color="text.primary">
                {dance.nameHeb || dance.nameEng || dance._id}
            </Typography>
            {dance.nameHeb && dance.nameEng && (
                <Typography variant="body2" color="text.secondary">
                    {dance.nameEng}
                </Typography>
            )}
            {displayName && (
                <Typography variant="caption" color="text.secondary">
                    {`${i18n.t(choreographersLabelKey)}: ${displayName}`}
                </Typography>
            )}
        </Stack>
    )
}

export default DanceItemInfo
